@if (!renderAsGrid) {
    <kno2-accordion
        [(value)]="expandedPanels"
        [multiple]="true"
        class="control-panel-items w-full">
        @for (item of items; track item) {
            <kno2-accordion-panel [value]="item.title">
                <div
                    kno2AccordionHeader
                    class="flex items-center">
                    <p class="font-bold mb-0 mr-2">{{ item.title }}</p>
                    <kno2-info-popover [content]="item.subtitle" />
                </div>
                <ng-template
                    kno2ControlPanelItemBody
                    [component]="item.component"
                    [context]="item.context"></ng-template>
            </kno2-accordion-panel>
        }
    </kno2-accordion>
}

@if (renderAsGrid) {
    <div class="item-grid control-panel-items w-full p-4">
        @for (item of items; track item) {
            <kno2-card
                [cardStyle]="item?.styles"
                class="m-0">
                <div
                    kno2CardTitle
                    class="flex items-center">
                    <p class="font-bold mb-0 mr-2">{{ item.title }}</p>
                    <kno2-info-popover [content]="item.subtitle" />
                </div>
                <ng-template
                    kno2ControlPanelItemBody
                    [component]="item.component"
                    [context]="item.context"></ng-template>
            </kno2-card>
        }
    </div>
}
